import React from "react";
import { Helmet } from "react-helmet";
const SoftwaredevHelmet = ({ title }) => {
  return (
    <Helmet>
      <title>
        Custom Software Development Company in USA
      </title>
      <meta
        name="description"
        content="Top custom software development company in USA offering ERP, CRM, CMS, and AI-powered solutions to scale, automate, and transform your business."
      />
    </Helmet>
  );
};

export default SoftwaredevHelmet;
